import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../../util/Rest';
import {
  INTEREST_TABLE,
  INTEREST_FREQUENCY,
  INTEREST_STEP_TABLE,
} from '../../../../constants/Lookup';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';

const initialData = {
  interestData: {},
  interestStatus: {},
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'interest',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchInterestData: (state, action) => {
      state.interestData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postInterestData: (state, action) => {
      state.interestStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetStatus: (state) => {
      state.interestStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const {
  fetchStart,
  fetchDropDownData,
  fetchError,
  fetchInterestData,
  postInterestData,
  resetMsg,
  resetStatus,
} = slice.actions;
export const fetchInterest = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [INTEREST_TABLE, INTEREST_FREQUENCY, INTEREST_STEP_TABLE],
      }),
      httpGet(`${CLIENT_MAINTENANCE}/find/clientinterest/${clientNumber}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const interestData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
        if (interestData?.status && interestData.status === 200) {
          dispatch(fetchInterestData(interestData.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postInterest = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/clientinterest`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postInterestData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetInterestStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
